"use strict";

module.exports = function (accumulator, order, product, component) {
  return component.wax_seal_style;
};